<div class="user-profile-menu">
  <button
    type="button"
    class="profile-trigger"
    [class.active]="menuOpen"
    (click)="toggleMenu()"
    aria-label="User menu"
    aria-haspopup="true"
    [attr.aria-expanded]="menuOpen"
  >
    <div class="avatar">
      @if (userAvatar) {
        <img [src]="userAvatar" [alt]="userName" class="avatar-image" />
      } @else {
        <span class="avatar-initials">{{ userInitials }}</span>
      }
    </div>
    <div class="profile-info">
      <span class="profile-name">{{ userName }}</span>
      <span class="profile-role">{{ userRole }}</span>
    </div>
    <span class="material-symbols-outlined dropdown-icon">{{menuOpen ? 'expand_less' : 'expand_more'}}</span>
  </button>

  @if (menuOpen) {
    <div class="menu-backdrop" (click)="closeMenu()"></div>
    <div class="dropdown-menu" role="menu">
      <button
        type="button"
        class="menu-item"
        role="menuitem"
        (click)="onProfileClick()"
      >
        <span class="material-symbols-outlined">person</span>
        <span>Profile</span>
      </button>
      <button
        type="button"
        class="menu-item"
        role="menuitem"
        (click)="onSettingsClick()"
      >
        <span class="material-symbols-outlined">settings</span>
        <span>Settings</span>
      </button>
      <div class="menu-divider"></div>
      <button
        type="button"
        class="menu-item logout"
        role="menuitem"
        (click)="onLogout()"
      >
        <span class="material-symbols-outlined">logout</span>
        <span>Logout</span>
      </button>
    </div>
  }
</div>
